module.exports = __webpack_public_path__ + "img/firework.969bd26a.png";